import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

import UnauthorizedContainWrapper from '../UnauthorizedContainWrapper';

const FORM_SRC =
  'https://docs.google.com/forms/d/e/1FAIpQLSfJOTo-x06yb71ndVStFsvd1QJnu1yZDtqail9sPnGDYYZkUA/viewform?embedded=true';

const useStyles = makeStyles(() =>
  createStyles({
    mainContainer: {
      height: '100%',
      width: '100%',
      maxWidth: 1600,
      margin: 'auto',
      padding: '40px 16px 70px',
      zIndex: 1,
      position: 'relative',

      '@media screen and (min-width: 768px)': {
        padding: '40px 100px 70px',
      },
    },
    formFrame: {
      width: '100%',
      maxWidth: 640,
      height: 900,
      border: 0,
      background: 'transparent',
    },
  })
);

export default function Status() {
  const classes = useStyles();

  return (
    <UnauthorizedContainWrapper>
      <Box className={classes.mainContainer}>
        <iframe
          className={classes.formFrame}
          src={FORM_SRC}
          title='Connect with Barometer'
          width='640'
          height='900'
        >
          Loading…
        </iframe>
      </Box>
    </UnauthorizedContainWrapper>
  );
}
